
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Innovacrystsonrentinmumbai() {



    const cardData =
    {
        keyword: ' Innova Crysta On Rent in Mumbai',
        heading: 'Skyline Cabs:  Innova Crysta On Rent in Mumbai',
        headingDescription: '​Skyline Cabs offers comfortable and reliable Innova Crysta on Rent in Mumbai services for a premium travel experience. Whether you are planning a family outing, corporate trip, or a special event, our well-maintained Innova Crysta vehicles and professional drivers ensure a smooth and enjoyable ride. Enjoy door-to-door pickups from anywhere in Mumbai, transparent pricing, flexible travel schedules, and 24/7 customer support. Book your Innova Crysta rental with Skyline Cabs today and travel in style and comfort across Maharashtra and beyond!',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

"topPlaces": [
    {
        "title": "Gateway of India",
        "description": "Built in 1924, the Gateway of India is one of Mumbai’s most iconic landmarks. Overlooking the Arabian Sea, this grand archway was constructed to commemorate the visit of King George V and Queen Mary. It’s a popular spot for tourists and locals alike, offering ferry rides to Elephanta Caves and scenic sunset views."
    },
    {
        "title": "Chhatrapati Shivaji Maharaj Terminus",
        "description": "A UNESCO World Heritage Site, this historic railway station is a masterpiece of Victorian Gothic architecture blended with Indian elements. Formerly known as Victoria Terminus, it is both a functioning railway station and an architectural marvel that reflects Mumbai’s colonial past."
    },
    {
        "title": "Marine Drive",
        "description": "Also known as the Queen’s Necklace, Marine Drive is a 3.6 km-long boulevard along the coast of South Mumbai. It’s a favorite hangout for evening strolls, sunsets, and panoramic views of the city skyline. At night, the streetlights resemble a string of pearls, adding to its charm."
    },
    {
        "title": "Elephanta Caves",
        "description": "Located on Elephanta Island, a short ferry ride from the Gateway of India, these UNESCO-listed rock-cut caves date back to the 5th–8th centuries. The caves are famous for their stunning sculptures and carvings dedicated to Lord Shiva, especially the majestic Trimurti sculpture."
    },
    {
        "title": "Siddhivinayak Temple",
        "description": "Dedicated to Lord Ganesha, the Siddhivinayak Temple in Prabhadevi is one of the most visited temples in Mumbai. Known for its spiritual energy and the faith it inspires, it draws thousands of devotees, including Bollywood celebrities and politicians."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and tomb located on an islet off the coast of Worli, Haji Ali Dargah is a symbol of Mumbai’s religious harmony. Connected to the mainland by a narrow causeway, it is both a pilgrimage site and an architectural gem offering serene sea views."
    },
    {
        "title": "Chor Bazaar",
        "description": "One of the oldest markets in Mumbai, Chor Bazaar is famous for antiques, vintage collectibles, furniture, and quirky treasures. Wandering through its crowded alleys offers a unique shopping experience and a glimpse into the city’s diverse culture and heritage."
    },
    {
        "title": "Juhu Beach",
        "description": "A popular beach destination in suburban Mumbai, Juhu Beach is known for its street food stalls, Bollywood celebrity homes, and leisurely atmosphere. It's the perfect spot for a seaside walk or indulging in local snacks like pav bhaji and bhel puri."
    },
    {
        "title": "Sanjay Gandhi National Park",
        "description": "Located in the northern part of Mumbai, this massive national park is a green escape from the urban hustle. Home to leopards, deer, and countless bird species, it also features the ancient Kanheri Caves and offers nature trails, boating, and safaris."
    },
    {
        "title": "Colaba Causeway",
        "description": "A bustling street market near the Gateway of India, Colaba Causeway is a shopper’s paradise filled with street stalls, boutiques, cafes, and colonial-era architecture. It’s ideal for picking up souvenirs, fashion, accessories, and enjoying Mumbai’s cosmopolitan vibe."
    }
],

"services": [
    {
      "name": "Innova Crysta on Rent Mumbai",
      "description": "Skyline Cabs offers Innova Crysta on rent in Mumbai for local and outstation travel. Enjoy premium comfort and space on every journey."
    },
    {
      "name": "Rent Innova Crysta for Travel Mumbai",
      "description": "Travel in style and comfort with Skyline Cabs' Innova Crysta rental service in Mumbai. Ideal for family trips, city tours, and more."
    },
    {
      "name": "Mumbai to Outstation Innova Crysta Hire",
      "description": "Planning an outstation trip from Mumbai? Hire an Innova Crysta from Skyline Cabs for a smooth and reliable travel experience."
    },
    {
      "name": "Innova Crysta for Events Mumbai",
      "description": "Make your events more convenient with Innova Crysta rentals from Skyline Cabs. Spacious and elegant transport for any occasion in Mumbai."
    },
    {
      "name": "Mumbai Airport Innova Crysta Rental",
      "description": "Book an Innova Crysta for airport pickups and drop-offs in Mumbai. Skyline Cabs ensures punctuality and comfort for every airport ride."
    },
    {
      "name": "Innova Crysta Hire for Wedding",
      "description": "Rent an Innova Crysta for weddings with Skyline Cabs. Perfect for family transportation or special guests on your big day."
    }
  ],
  "tableData": [
    ["Innova Crysta on Rent Mumbai", "Rent Innova Crysta for Travel Mumbai"],
    ["Mumbai to Outstation Innova Crysta Hire", "Innova Crysta for Events Mumbai"],
    ["Mumbai Airport Innova Crysta Rental", "Innova Crysta Hire for Wedding"]
  ],



  whychoose: [
    {
      "WhyChooseheading": "Innova Crysta on Rent in Mumbai",
      "WhyChoosedescription": "Rent the premium Toyota Innova Crysta in Mumbai for ultimate comfort and reliability. Ideal for city travel, airport transfers, outstation trips, or corporate rides."
    },
    {
      "WhyChooseheading": "Spacious and Premium Interiors",
      "WhyChoosedescription": "Enjoy luxurious interiors with ample legroom, plush seating, and smooth suspension—perfect for family travel, business trips, or group outings."
    },
    {
      "WhyChooseheading": "Perfect for City and Outstation Travel",
      "WhyChoosedescription": "Whether it’s a short city ride or a long outstation journey, Innova Crysta delivers unmatched performance and comfort throughout."
    },
    {
      "WhyChooseheading": "Loaded with Modern Features",
      "WhyChoosedescription": "Equipped with automatic climate control, touchscreen infotainment, charging ports, and more to enhance your travel experience."
    },
    {
      "WhyChooseheading": "Experienced and Courteous Chauffeurs",
      "WhyChoosedescription": "Our professional drivers ensure safe, smooth, and on-time travel, making your ride stress-free and enjoyable."
    },
    {
      "WhyChooseheading": "Hygienic, Sanitized, and Well-Maintained Vehicle",
      "WhyChoosedescription": "We prioritize cleanliness and safety with regular sanitization and thorough vehicle checks before every trip."
    },
    {
      "WhyChooseheading": "Flexible Rental Plans for Every Need",
      "WhyChoosedescription": "Choose from hourly, daily, or multi-day rental options tailored to your personal or business travel needs in Mumbai."
    },
    {
      "WhyChooseheading": "Easy Booking and 24/7 Customer Support",
      "WhyChoosedescription": "Book your Innova Crysta online or via phone anytime. Our 24/7 support team ensures a seamless and quick booking process."
    }
  ]
  
  
  
  
  
  









    }

    const faqData = [
        {
            id: 1,
            question: 'How can I rent an Innova Crysta in Mumbai with Skyline Cabs?',
            answer:
                'Renting an Innova Crysta in Mumbai is quick and easy. You can book via our website, mobile app, or by calling our customer support. Just select your pickup location, date, and travel plan to get started.',
        },
        {
            id: 2,
            question: 'How many passengers can the Innova Crysta accommodate?',
            answer:
                'The Innova Crysta can comfortably seat 6 to 7 passengers. It’s perfect for family outings, business trips, airport transfers, and outstation travel.',
        },
        {
            id: 3,
            question: 'Is the Innova Crysta suitable for long-distance travel?',
            answer:
                'Absolutely! The Innova Crysta is known for its smooth ride, powerful engine, and spacious interiors. It’s ideal for both city travel and long outstation trips.',
        },
        {
            id: 4,
            question: 'Are the rental prices for Innova Crysta in Mumbai fixed?',
            answer:
                'Yes, we offer fixed and transparent pricing. Your fare includes the vehicle, driver charges, fuel, tolls, and taxes. You’ll receive the final quote before confirming the booking.',
        },
        {
            id: 5,
            question: 'Can I book an Innova Crysta for a few hours or a full day?',
            answer:
                'Yes, you can book an Innova Crysta for hourly rentals, half-day, full-day, or even multiple days depending on your travel needs. Custom packages are available upon request.',
        },
        {
            id: 6,
            question: 'Is the Innova Crysta air-conditioned and comfortable?',
            answer:
                'Yes, all our Innova Crysta vehicles are air-conditioned and well-maintained. They feature plush interiors, ample luggage space, and advanced safety features.',
        },
        {
            id: 7,
            question: 'Can I rent an Innova Crysta for corporate or wedding use?',
            answer:
                'Yes, our Innova Crysta rental is suitable for all types of travel including corporate transfers, VIP pickups, weddings, and family functions. Professional chauffeurs ensure a smooth experience.',
        },
        {
            id: 8,
            question: 'What payment options are available for renting an Innova Crysta?',
            answer:
                'We accept payments through UPI, credit/debit cards, net banking, and cash. All online transactions are processed securely and confirmed instantly.',
        },
        {
            id: 9,
            question: 'Can I cancel or reschedule my Innova Crysta booking?',
            answer:
                'Yes, you can modify or cancel your booking through our app, website, or by contacting customer support. Our flexible policies are designed to accommodate changes in your plans.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for Innova Crysta rental in Mumbai?',
            answer:
                'Skyline Cabs offers premium Innova Crysta rentals with professional drivers, transparent pricing, and 24/7 customer support. Our vehicles are clean, reliable, and perfect for all types of journeys.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Rahul Deshmukh",
            rating: 5,
            review: "I rented an Innova Crysta for a weekend trip from Mumbai to Pune. The car was spotless, extremely comfortable, and the driver was very polite. Great experience with Skyline Cabs!"
        },
        {
            name: "Ms. Sneha Mehta",
            rating: 4,
            review: "The Innova Crysta was perfect for our airport transfer. Spacious and smooth ride. Slight delay in arrival, but the service was professional and courteous."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



  const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Crysta On Rent in Mumbai",
  "image": "https://skylinecabs.com/assets/images/innova-crysta-on-rent-mumbai.jpg",
  "description": "Book Innova Crysta on rent in Mumbai with Skyline Cabs for luxurious and comfortable travel. Perfect for family trips, business tours, airport transfers, and outstation journeys. Enjoy spacious AC rides with pushback seats and professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8872"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2600",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/innova-crysta-on-rent-in-mumbai"
  }
};



      
      
      

    return (
        <div>

<Helmet>
  <title>Innova Crysta On Rent in Mumbai | Luxury 6,7 Seater Cab | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Innova Crysta on rent in Mumbai with Skyline Cabs for luxurious and comfortable travel. Perfect for family trips, business tours, airport transfers, and outstation journeys. Enjoy spacious AC rides with pushback seats and professional drivers." 
  />
  <meta 
    name="keywords" 
    content="Innova Crysta On Rent in Mumbai, 7 Seater Innova Crysta Cab Mumbai, Innova Crysta Booking Mumbai, AC Innova Crysta Rental, Outstation Innova Crysta Mumbai, Luxury SUV Rental Mumbai, Mumbai Airport Innova Hire, Skyline Cabs Mumbai SUV" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/91.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Innovacrystsonrentinmumbai;